// removed by extract-text-webpack-plugin
module.exports = {"fastest":".15s","linear":"cubic-bezier(0, 0, 1, 1)","section":"f_XZYw1DDVjPcYFnbHRjp","active":"_2rYv2d7bNG7K7cssraTCE0","fade":"_2ThxkrVAf5WQo9bjth2IPa","in":"_36aq9q8dsOJiGzTWPJBhih"};


//////////////////
// WEBPACK FOOTER
// ./src/uis/elements/Tabs/TabsSection/Container/Container.css
// module id = 1148
// module chunks = 0